import { createTheme } from '@mui/material';
import { theme as sharedTheme } from '@barracuda/shared/styles/theme';

export { $fontOpenSans, mediaQuery } from '@barracuda/shared/styles/theme';

// Theme is not imported straight from shared. This easily allow exclusively extend theme in single package.
// ignoring TS2590: Expression produces a union type that is too complex to represent.
// @ts-ignore
export const theme = createTheme(sharedTheme);
